import { settings as settingsIcon } from '@equinor/eds-icons';
import type { SidebarLink } from '../types';

/**
 * Build simulation sidebar links for a given simulationId.
 * "progress" is the default section (no search param needed),
 * "parameters" uses `?section=parameters`.
 */
export const getSimulationLinks = (simulationId: string): SidebarLink[] => [
  {
    title: 'Scenario build',
    path: `/simulations/${simulationId}`,
    icon: settingsIcon,
    nonCollapsible: true,
    children: [
      {
        title: 'Simulation progress',
        path: `/simulations/${simulationId}`,
      },
      {
        title: 'Input parameters',
        path: `/simulations/${simulationId}?section=parameters`,
      },
    ],
  },
];
